import { Component } from '@angular/core';
import { SharedModule } from 'src/app/shared';

@Component({
  selector: 'app-information-to-public',
  imports: [SharedModule],
  templateUrl: './information-to-public.component.html',
  styleUrl: './information-to-public.component.scss'
})
export class InformationToPublicComponent {

}
